import React from "react";
import { useNavigate } from "react-router-dom"; // Import useNavigate
import toast from "react-hot-toast"; // Import toast for user feedback

const Logout = () => {
    const navigate = useNavigate();

    // --- Logout Handler ---
    const handleLogout = () => {
        // 1. Remove user authentication data from localStorage
        window.localStorage.removeItem("token");
        window.localStorage.removeItem("clientProfile");
        
        // 2. Provide feedback
        toast.success("Successfully logged out!");

        // 3. Redirect to the home page (or login page)
        navigate("/", { replace: true }); 
    };

    // --- Cancel Handler ---
    const handleCancel = () => {
        // Redirect back to the previous page or dashboard
        navigate(-1); // navigate(-1) goes back one step in history
    };

    return (
        <div className="dashboard-pages-padding" style={{ marginTop: "100px", textAlign: "center" }}>
            <div style={{ maxWidth: "400px", margin: "0 auto", padding: "30px", border: "1px solid #ccc", borderRadius: "8px", boxShadow: "0 2px 4px rgba(0,0,0,0.1)" }}>
                
                <h1 className="mb-4">Logout</h1>
                <p className="lead mb-4">Are you sure you want to log out?</p>
                
                <div className="logout-button-section d-flex justify-content-center gap-3">
                    
                    {/* Logout Button (Primary Action) */}
                    <button 
                        onClick={handleLogout} 
                        className="btn btn-danger w-50"
                        // Replace 'save-profile-btn' with a standard Bootstrap class for better styling
                    >
                        Logout
                    </button>
                    
                    {/* Cancel Button (Secondary Action) */}
                    <button 
                        onClick={handleCancel} 
                        className="btn btn-secondary w-50"
                        // Replace 'cancel-btn' with a standard Bootstrap class
                    >
                        Cancel
                    </button>
                    
                </div>
            </div>
        </div>
    );
};

export default Logout;